const ANIMATION_DURATION = 200;
const ANIMATION_DELAY = 500;

export { ANIMATION_DELAY, ANIMATION_DURATION };
